(() => {
  const galleries = new WeakMap();

  const setActiveMedia = (root, mediaId, animate = true) => {
    const gallery = root.querySelector('[data-product-hero-gallery]');
    const instance = gallery ? galleries.get(gallery) : null;
    if (!instance || !mediaId) return;

    const index = instance.mediaIds.indexOf(String(mediaId));
    if (index < 0) return;
    instance.swiper.slideTo(index, animate ? 500 : 0);
  };

  const updateState = (gallery, swiper, mediaIds) => {
    const activeIndex = swiper.activeIndex || 0;
    const activeMediaId = mediaIds[activeIndex];
    const progress = mediaIds.length > 1 ? ((activeIndex + 1) / mediaIds.length) * 100 : 100;

    gallery.style.setProperty('--stellr-gallery-progress', `${progress}%`);
    gallery.querySelectorAll('[data-product-gallery-target]').forEach((button) => {
      if (button.dataset.productGalleryTarget === activeMediaId) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });

    gallery.querySelectorAll('[data-product-gallery-slide] video').forEach((video, index) => {
      if (index !== activeIndex) video.pause();
    });
  };

  const initGallery = (gallery) => {
    if (!gallery || galleries.has(gallery) || !window.Swiper) return;

    const viewport = gallery.querySelector('[data-product-gallery-viewport]');
    const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
    if (!viewport || !slides.length) return;

    const mediaIds = slides.map((slide) => String(slide.dataset.mediaId || ''));
    const initialMediaId = gallery.closest('[data-product-root]')
      ?.querySelector('[data-variant-option]:checked')
      ?.dataset.mediaId;
    const initialSlide = Math.max(0, mediaIds.indexOf(String(initialMediaId || '')));
    const swiper = new window.Swiper(viewport, {
      initialSlide,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 560,
      grabCursor: slides.length > 1,
      watchOverflow: true,
      keyboard: { enabled: true, onlyInViewport: true },
      breakpoints: {
        750: { allowTouchMove: false },
      },
      on: {
        init(instance) {
          updateState(gallery, instance, mediaIds);
        },
        slideChange(instance) {
          updateState(gallery, instance, mediaIds);
        },
      },
    });

    gallery.querySelectorAll('[data-product-gallery-target]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = mediaIds.indexOf(String(button.dataset.productGalleryTarget));
        if (index >= 0) swiper.slideTo(index, 500);
      });
    });

    galleries.set(gallery, { swiper, mediaIds });
  };

  const destroyGallery = (gallery) => {
    const instance = galleries.get(gallery);
    if (!instance) return;
    instance.swiper.destroy(true, true);
    galleries.delete(gallery);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-product-hero-gallery]').forEach(initGallery);
  };

  window.StellrProductGallery = { setActiveMedia };
  document.addEventListener('DOMContentLoaded', () => initAll());
  window.addEventListener('load', () => initAll(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-product-hero-gallery]').forEach(destroyGallery);
  });
})();
